"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Device;
(function (Device) {
    Device[Device["All"] = -1] = "All";
    Device[Device["Desktop"] = 1] = "Desktop";
    Device[Device["Mobile"] = 2] = "Mobile";
    Device[Device["Tablet"] = 3] = "Tablet";
    Device[Device["MobileSdk"] = 4] = "MobileSdk";
    Device[Device["TabletSdk"] = 5] = "TabletSdk";
})(Device = exports.Device || (exports.Device = {}));
var DeviceLabel;
(function (DeviceLabel) {
    DeviceLabel["All"] = "all";
    DeviceLabel["Desktop"] = "desktop";
    DeviceLabel["Mobile"] = "mobile";
    DeviceLabel["Tablet"] = "tablet";
})(DeviceLabel = exports.DeviceLabel || (exports.DeviceLabel = {}));
var OpenApiDevice;
(function (OpenApiDevice) {
    OpenApiDevice["All"] = "all";
    OpenApiDevice["Desktop"] = "desktop";
    OpenApiDevice["Mobile"] = "mobile";
    OpenApiDevice["Tablet"] = "tablet";
})(OpenApiDevice = exports.OpenApiDevice || (exports.OpenApiDevice = {}));
exports.DeviceKey = {
    [Device.All]: 'DEVICE.ALL_DEVICES',
    [Device.Desktop]: 'DEVICE.DESKTOP',
    [Device.Mobile]: 'DEVICE.MOBILE',
    [Device.Tablet]: 'DEVICE.TABLET',
    [Device.MobileSdk]: 'DEVICE.MOBILE',
    [Device.TabletSdk]: 'DEVICE.TABLET',
};
exports.DeviceIcon = {
    [Device.All]: 'all',
    [Device.Desktop]: 'desktop',
    [Device.Mobile]: 'mobile',
    [Device.Tablet]: 'tablet',
    [Device.MobileSdk]: 'mobile',
    [Device.TabletSdk]: 'tablet',
};
//# sourceMappingURL=device.js.map